import styled, { css } from 'styled-components';

export type TagVariants =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'p'
  | 'span'
  | 'div';
export type Type =
  | 'Display'
  | 'Headline'
  | 'Title'
  | 'Body'
  | 'Label'
  | 'Caption'
  | 'Link';

export type Size = 'large' | 'medium' | 'small';

export type Style =
  | 'extrabold'
  | 'bold'
  | 'semibold'
  | 'normal'
  | 'light'
  | 'extralight';

export const fontSizes = {
  Display: { large: '96px', medium: '60px', small: '48px' },
  Headline: { large: '36px', medium: '32px', small: '30px' },
  Title: { large: '28px', medium: '24px', small: '20px' },
  Body: { large: '18px', medium: '16px', small: '14px' },
  Label: { large: '13px', medium: '12px', small: '11px' },
  Caption: { large: '11px', medium: '10px', small: '9px' },
  Link: { large: '18px', medium: '16px', small: '14px' },
};

export const fontWeights = {
  extralight: 250,
  light: 300,
  normal: 400,
  semibold: 500,
  bold: 700,
  extrabold: 900,
};

export interface TypographyStyledProps {
  color?: string;
  $style: Style;
  $type: Type;
  $size: Size;
  onClick?: () => void;
}

export const TypographyStyled = styled.div<TypographyStyledProps>`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: ${props => {
    return props.color || '#0C0C0C';
  }};
  font-weight: ${props => {
    return fontWeights[props.$style];
  }};
  font-size: ${props => {
    return fontSizes[props.$type][props.$size];
  }};
  ${props => {
    return (
      props.$type === 'Link' &&
      css`
        text-decoration: underline;
      `
    );
  }}
  ${props => {
    return (
      props.onClick &&
      css`
        cursor: pointer;
      `
    );
  }}
`;
